/* eslint-disable quote-props */
import { ComponentUtils } from '@/mixins';
import ShCard from '@/components/Helpers/ShCard';
import HintAndExplanation from '@/components/Common/HintAndExplanation';
import LayoutForSingleConfigurationRow from '../Common/LayoutForSingleConfigurationRow';
import DayTimeSchedulerItem from './DayTimeSchedulerItem';
import WidgetBehaviorSelect from './WidgetBehaviorSelect';
// componets for hints
import AgentsGroupInhoursBehavior from './HintsTemplates/AgentsGroupInhoursBehavior';
import VirtualDepartmentInhoursBehavior from './HintsTemplates/VirtualDepartmentInhoursBehavior';
import InvisibleAfterHoursBehavior from './HintsTemplates/InvisibleAfterHoursBehavior';
import CallbackAutoAfterhoursBehavior from './HintsTemplates/CallbackAutoAfterhoursBehavior';
import CallbackManuallyAfterhoursBehavior from './HintsTemplates/CallbackManuallyAfterhoursBehavior';
import FeedbackAfterConnection from './HintsTemplates/FeedbackAfterConnection';
import MissedCallRequestForContact from './HintsTemplates/MissedCallRequestForContact';

// @vue/component
export default {
  name: 'WidgetBehaviorConfiguration',

  components: {
    ShCard,
    HintAndExplanation,
    LayoutForSingleConfigurationRow,
    DayTimeSchedulerItem,
    WidgetBehaviorSelect,
    FeedbackAfterConnection,
    MissedCallRequestForContact,
    // component names deliberately using camellcase as they are loaded dynamically based on the names of possible widget behaviors of the API
    'agents_group': AgentsGroupInhoursBehavior,
    'virtual_department': VirtualDepartmentInhoursBehavior,
    'invisible': InvisibleAfterHoursBehavior,
    'callback_auto': CallbackAutoAfterhoursBehavior,
    'callback_manually': CallbackManuallyAfterhoursBehavior,
  },

  mixins: [ComponentUtils],

  props: {
    widget: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
    };
  },

  computed: {
    behaviorTypes() {
      const possibleBehaviors = this.$store.getters['authorization/accessPermissionsDefinitions'].behavior;
      return this.$store.getters['settings/behaviorTypes'].filter(item => possibleBehaviors[item.behavior]);
    },
    accessPermissionsDefinitions() {
      return this.$store.getters['authorization/accessPermissionsDefinitions'];
    },
    isHintShowed() {
      return this.mCopy.widget.config && this.mCopy.widget.config.call_behavior !== null;
    },

  },

  created() {
    this.$store.dispatch('settings/getBehaviorTypes');
    this.$store.dispatch('agents/getList');
    this.$store.dispatch('departments/getList');
    this.mMakeCopyFromProps('widget');
  },

  methods: {
    handleChangeSchedule(day, daySchedule) {
      this.mCopy.widget.schedule = {
        ...this.mCopy.widget.schedule,
        [`${day}_is_active`]: daySchedule.isActive,
        [`${day}_ah_from`]: daySchedule.availabilityHoursFrom,
        [`${day}_ah_to`]: daySchedule.availabilityHoursTo,
      };
      this.updateWidget();
    },
    handleChangeCallBehavior(newWidgetDetails) {
      this.$store.dispatch('widgets/updateWidget', { newWidgetDetails });
    },
    updateWidget() {
      const newWidgetDetails = this.mCopy.widget;
      this.$store.dispatch('widgets/updateWidget', { newWidgetDetails });
    },
  },
};
